import regexp from '@/common/regexp';

const SSN_LAST4_LENGTH = 4;

export const getMaskedDependentSsn = (ssn?: string | null) => {
  const last4 = (ssn || '').replace(regexp.ALL_NON_NUMERIC, '').slice(-SSN_LAST4_LENGTH);

  return last4.length === SSN_LAST4_LENGTH ? `***-**-${last4}` : undefined;
};

export const isValidDependentSsn = (ssn?: string) =>
  !ssn || regexp.SSN_WITH_DASHES.test(ssn) || regexp.SSN_MASKED_LAST4.test(ssn);

export const formatDependentSsnToServer = (ssn?: string | null) =>
  ssn && regexp.SSN_WITH_DASHES.test(ssn) ? { ssn } : {};
